export const ADMIN_INFORMATION = [
  {
    title: "Total Admins",
    icon: "mdi-all-inclusive",
  },
  {
    title: "Admin",
    icon: "mdi-security",
  },
  {
    title: "Super Admin",
    icon: "mdi-shield-crown-outline",
  },
];

export const CUSTOMER_INFORMATION = [
  {
    title: "Total Customers",
    count: 0,
    icon: "mdi-all-inclusive",
    trend: "up",
    percentage: 3.2,
  },
  {
    title: "New Customers",
    count: 0,
    icon: "mdi-account-multiple-outline",
    trend: "down",
    percentage: 3.2,
  },
  {
    title: "MAU",
    count: 0,
    icon: "mdi-account-star-outline",
    trend: "up",
    percentage: 3.2,
  },
];

export const BOOKING_INFORMATION = [
  {
    title: "Total Bookings",
    count: 0,
    icon: "mdi-all-inclusive",
    trend: "up",
    percentage: 3.2,
  },
  {
    title: "Revenue",
    count: 0,
    icon: "mdi-cash-multiple",
    currency: true,
    trend: "down",
    percentage: 3.2,
  },
  {
    title: "Cancellations",
    count: 0,
    icon: "mdi-cancel",
    trend: "up",
    percentage: 3.2,
  },
];

export const OPERATOR_INFORMATION = [
  {
    title: "Active Operators",
    count: 0,
    icon: "mdi-account-hard-hat-outline",
    trend: "up",
    percentage: 3.2,
  },
  {
    title: "Pending Operators",
    count: 0,
    icon: "mdi-account-alert-outline",
    trend: "down",
    percentage: 3.2,
  },
  {
    title: "Live Buses",
    count: 0,
    icon: "mdi-cancel",
    trend: "up",
    percentage: 3.2,
  },
];

export const BUS_INFORMATION = [
  {
    title: "Active Buses",
    count: 0,
    icon: "mdi-bus",
    trend: "up",
    percentage: 3.2,
  },
  {
    title: "Pending Buses",
    count: 0,
    icon: "mdi-bus-alert",
    trend: "down",
    percentage: 3.2,
  },
  {
    title: "Live Operators",
    count: 0,
    icon: "mdi-bus-marker",
    trend: "up",
    percentage: 3.2,
  },
];

export const CITY_INFORMATION = [
  {
    title: "Total Cities",
    count: 0,
    icon: "mdi-home-city-outline",
    trend: "up",
    percentage: 3.2,
  },
  {
    title: "Total Bookings",
    count: 0,
    icon: "mdi-book-arrow-up-outline",
    trend: "down",
    percentage: 3.2,
  },
  {
    title: "Live Operators",
    count: 0,
    icon: "mdi-developer-board",
    trend: "up",
    percentage: 3.2,
  },
];

export const SETTLEMENT_INFORMATION = [
  {
    title: "Total Settlements",
    count: 0,
    icon: "mdi-cash",
    trend: "up",
    percentage: 3.2,
  },
  {
    title: "Total Amount Settled",
    count: 0,
    icon: "mdi-cash-check",
    trend: "down",
    percentage: 3.2,
  },
  {
    title: "Failed Settlements",
    count: 0,
    icon: "mdi-cash-remove",
    trend: "up",
    percentage: 3.2,
  },
];

export const COUPON_INFORMATION = [
  {
    title: "Total Coupons Created",
    count: 0,
    icon: "mdi-sale-outline",
    trend: "up",
    percentage: 3.2,
  },
  {
    title: "Active Coupons",
    count: 0,
    icon: "mdi-ticket-percent-outline",
    trend: "down",
    percentage: 3.2,
  },
  {
    title: "Total Value of Coupons ",
    count: 0,
    icon: "mdi-currency-rupee",
    currency: true,
    trend: "up",
    percentage: 3.2,
  },
];

export const TRANSACTION_INFORMATION = [
  {
    title: "Total Transactions",
    count: 0,
    icon: "mdi-bank-transfer",
    trend: "up",
    percentage: 3.2,
  },
  {
    title: "Failed Transaction",
    count: 0,
    icon: "mdi-cash-off",
    trend: "down",
    percentage: 3.2,
  },
  {
    title: "Refund Pending",
    count: 0,
    icon: "mdi-cash-refund",
    trend: "up",
    percentage: 3.2,
  },
];

export const REFFERAL_INFORMATION = [
  {
    title: "Total Refferals",
    count: 0,
    icon: "mdi-bank-transfer",
    trend: "up",
    percentage: 3.2,
  },
  {
    title: "User Refferals",
    count: 0,
    icon: "mdi-cash-off",
    trend: "down",
    percentage: 3.2,
  },
  {
    title: "Total Reward Distributed",
    count: 0,
    icon: "mdi-cash-refund",
    trend: "up",
    percentage: 3.2,
  },
];

export const REFEREE_INFORMATION = [
  {
    label: "Total Referrals",
    value: 0,
    gradient: "linear-gradient(135deg, #4e73df, #224abe)",
  },
  {
    label: "Success Referrals",
    value: 0,
    gradient: "linear-gradient(135deg, #1cc88a, #13855c)",
  },
  {
    label: "Rewards Earned",
    value: 0,
    gradient: "linear-gradient(135deg, #f6c23e, #dda20a)",
  },
  {
    label: "Dormant Referrals",
    value: 0,
    gradient: "linear-gradient(135deg, #858796, #5a5c69)",
  },
  {
    label: "Total Revenue",
    value: 0,
    gradient: "linear-gradient(135deg, #36b9cc, #258391)",
  },
];

export const CUSTOMER_DETAIL_INFORMATION = [
  {
    label: "Total Revenue",
    value: 0,
    gradient: "linear-gradient(135deg, #6366f1, #4338ca)",
  },
  {
    label: "Total Bookings",
    value: 0,
    gradient: "linear-gradient(135deg, #22c55e, #15803d)",
  },
  {
    label: "Cancellations",
    value: 0,
    gradient: "linear-gradient(135deg, #f97316, #c2410c)",
  },
  {
    label: "Total Refferals",
    value: 0,
    gradient: "linear-gradient(135deg, #06b6d4, #0e7490)", // Cyan
  },
  {
    label: "Searches",
    value: 0,
    gradient: "linear-gradient(135deg, #64748b, #334155)",
    isShowInfo: true,
  },
];

export const POS_INFORMATION = [
  {
    title: "Total Bookings",
    key: "total_bookings",
    icon: "mdi-all-inclusive",
  },
  {
    title: "Total POS",
    key: "total_pos",
    icon: "mdi-cellphone-settings",
  },
  {
    title: "Live POS",
    key: "live_pos",
    icon: "mdi-bell-ring",
  },
  {
    title: "Total Cash Collected",
    key: "cash_collected",
    currency:true,
    icon: "mdi-cellphone-settings",
  },
  {
    title: "Total Tickets Issued",
    key: "tickets_issued",
    icon: "mdi-bell-ring",
  },
];

export const POS_BOOKING_INFORMATION = [
  {
    title: "Tickets Issued",
    icon: "mdi-ticket-confirmation",
    trend: "up",
    percentage: 3.2,
  },
  {
    title: "Total Revenue",
    currency : true,
    icon: "mdi-cash-multiple",
    trend: "down",
    percentage: 3.2,
  },
  {
    title: "Cash Collected",
    currency : true,
    icon: "mdi-cash-check",
    trend: "up",
    percentage: 3.2,
  },
  {
    title: "Online Bookings",
    icon: "mdi-cellphone-sound",
    trend: "up",
    percentage: 3.2,
  },
  {
    title: "POS Bookings",
    icon: "mdi-devices",
    trend: "up",
    percentage: 3.2,
  },
];

export const ADVERTISEMENT_INFORMATION = [
  {
    title: "Active Ads",
    count: 0,
    icon: "mdi-all-inclusive",
  },
  {
    title: "Cities with Ads",
    count: 0,
    icon: "mdi-cellphone-settings",
  },
  {
    title: "Devices with Ads",
    count: 0,
    icon: "mdi-bell-ring",
  },
];
export const ADVERTISEMENT_METRICS_INFORMATION = [
  {
    title: "Assigned Ticket Counts",
    count: 0,
    icon: "mdi-all-inclusive",
  },
  {
    title: "Cash Fare Amount",
    count: 0,
    icon: "mdi-cellphone-settings",
    currency: true,
  },
  {
    title: "Is unlimited",
    count: 0,
    icon: "mdi-bell-ring",
  },
  {
    title: "Current Usage Count",
    count: 0,
    icon: "mdi-bell-ring",
  },
  {
    title: "Digital Fare Amount",
    count: 0,
    icon: "mdi-bell-ring",
    currency: true,
  },
  {
    title: "Passengers Count",
    count: 0,
    icon: "mdi-bell-ring",
  },
  {
    title: "Total Fare Amount",
    count: 0,
    icon: "mdi-bell-ring",
    currency: true,
  },
  {
    title: "Maximum Allowed Usage Count",
    count: 0,
    icon: "mdi-bell-ring",
  },
  {
    title: "Remaining Usage Count",
    count: 0,
    icon: "mdi-bell-ring",
  },
];

export const BOOKING_SUMMARY = [
  {
    title: "Total Bookings",
    count: 0,
    icon: "mdi-clock-outline"
  },
  {
    title: "Total cancellations",
    count: 0,
    icon: "mdi-cancel"
  },
  {
    title: "Completed Bookings",
    count: 0,
    icon: "mdi-calendar-check"
  },
  {
    title: "Total Revenue",
    currency: true,
    count: 0,
    icon: "mdi-cash-multiple"
  },
];

export const CUSTOMER_SUMMARY = [
  {
    title: "Total Customers",
    count: 0,
    icon: "mdi-calendar-check",
  },
  {
    title: "New Customers",
    count: 0,
    icon: "mdi-cash-multiple",
  },
  {
    title: "Monthly Active",
    count: 0,
    icon: "mdi-clock-outline",
  },
  {
    title: "Avg.Ticket value",
    currency: true,
    count: 0,
    icon: "mdi-cancel",
  },
];

export const VEHICLE_PARTNER_SUMMARY = [
  {
    title: "Total Parterner Live",
    count: 0,
    icon: "mdi-calendar-check",
  },
  {
    title: "New Partners",
    count: 0,
    icon: "mdi-cash-multiple",
  },
  {
    title: "Pending Partners",
    count: 0,
    icon: "mdi-clock-outline",
  },
  {
    title: "Daily Active Partners",
    count: 0,
    icon: "mdi-cancel",
  },
];

export const BUS_SUMMARY = [
  {
    title: "Total Buses",
    count: 0,
    icon: "mdi-calendar-check",
  },
  {
    title: "New Buses",
    count: 0,
    icon: "mdi-cash-multiple",
  },
  {
    title: "Pending Buses",
    count: 0,
    icon: "mdi-clock-outline",
  },
  {
    title: "Total Active Cities",
    count: 0,
    icon: "mdi-cancel",
  },
];

export const BONUS_INFORMATION = [
  {
    title: "Welcome Bonus",
    subtitle:"Percentage Applied",
    count: 0,
    icon: "mdi-calendar-check",
  },
  {
    title: "Refferal Bonus",
    subtitle:"Percentage Applied",
    count: 0,
    icon: "mdi-cash-multiple",
  },
  {
    title: "Wallet Bonus",
    subtitle:"Percentage Applied",
    count: 0,
    icon: "mdi-clock-outline",
  }
];

export const AD_METRICS_INFORMATION = [
  {
    title: "Welcome Bonus",
    subtitle:"Percentage Applied",
    count: 0,
    icon: "mdi-calendar-check",
  },
  {
    title: "Refferal Bonus",
    subtitle:"Percentage Applied",
    count: 0,
    icon: "mdi-cash-multiple",
  },
  {
    title: "Wallet Bonus",
    subtitle:"Percentage Applied",
    count: 0,
    icon: "mdi-clock-outline",
  }
];
